import React from "react";
import userpic from '../../assets/user-default.png';
import PlayerInjured from "../../assets/icons/playerinjured";

const NBAPlayerStandings = props => {
  let className = '';
  if(props.playerposition == 'C') {
    className = 'quarterback';
  } else if(props.playerposition == 'F'){
    className = 'runningback';
  } else if(props.playerposition == 'G'){
    className = 'widereceiver';
  } else if(props.playerposition == 'FC'){
    className = 'tightend';
  } else if(props.playerposition == 'GF'){
    className = 'flexplayer';
  } 
  let player_score = (props.playerposition== 'DF') ? props.team_score : props.score;


  const gameScore =  (opponent_team_key, team_key, away_team, home_team, away_score, home_score) => { 
    let gameScore = '';
    if(opponent_team_key == away_team) {
      gameScore = away_score+' - '+home_score;
    } else if(opponent_team_key == home_team) {
      gameScore = home_score+' - '+away_score;
    }
    return gameScore;
  }
  return (
    <div className="player-standings">

      <div className={"standing-card " + className}>
        <div className="player-info">
          <div className="position">{ props.playerposition}</div>
          <figure>{props.player_pic && props.player_pic != "" ? <img src={props.player_pic} alt="KO" /> : <img src={userpic} alt="KO" />}</figure>
          <div className="name">{props.playername}</div>
          {props.is_player_injured && <div className="injury-update"><PlayerInjured injuryStatus = {props.is_player_injured}/></div>}
        </div>
        <div className="standing-stats">
          <div className="stat-value game-value">
            <div className="game-group">
              <label>Game</label><p>
              {props.opponent_team_key}
              {props.team_key && props.opponent_team_key &&props.opponent_team_key != "" ? ' @ ' : ''}
              {props.team_key} 
              </p>
            </div>
            <div className="live-group">
              {props.is_canceled == 1 && <><label>Cancelled</label></> }
              {(props.has_started == 1 && props.is_inprogress == 1) && <><label>LIVE</label><p>{gameScore(props.opponent_team_key,props.team_key, props.away_team, props.home_team, props.away_score, props.home_score) }</p></> }
              {(props.has_started == 1 && props.is_over == 1) && <><label>Final</label><p>{gameScore(props.opponent_team_key,props.team_key, props.away_team, props.home_team, props.away_score, props.home_score) }</p></> }
            </div>
          </div>

          <div className="stat-value">
            <label>Score</label><p>{player_score}</p>
          </div> 
          <div className="stat-value">
            <label>Points</label><p>{props.offense_points}</p>
          </div> 
          <div className="stat-value">
            <label>Assists</label><p>{props.offense_assists}</p>
          </div> 
          <div className="stat-value">
            <label>Rebounds</label><p>{props.total_rebounds}</p>
          </div> 
          <div className="stat-value">
            <label>Turnovers</label><p>{props.defense_turn_over}</p>
          </div>
          <div className="stat-value">
            <label>Blocks</label><p>{props.defense_blocks}</p>
          </div>  

          
        </div>
      </div>

    </div>
  );
}

export default (NBAPlayerStandings);
